var window=global;var $CLJS=require("./cljs_env.js");
'use strict';var xia=require("moment-timezone");module.exports=xia;